import React from 'react';
import styled from 'styled-components';
import { fieldErrorStyles } from './inputStyles';
import { UnreachableCaseError } from 'ts-essentials';
import { IStyled } from '../../styles/types';

interface IFormFieldLengthError {
  type: 'length';
  targetElement: string;
  maxLength: number;
  isDescription?: boolean;
  isComment?: boolean;
}

interface IFormFieldDuplicateError {
  type: 'duplicate';
  targetElement: string;
  name: string;
}

interface IFormFieldCustomError {
  type: 'custom';
  customError: string;
}

type IProps = IStyled &
  (IFormFieldLengthError | IFormFieldDuplicateError | IFormFieldCustomError);

const Container = styled.div`
  ${fieldErrorStyles};
`;

export default ({ className, ...props }: IProps) => {
  const getErrorMessage = () => {
    const { type } = props;
    if (type === 'length') {
      const { targetElement, maxLength, isDescription, isComment } = props;

      return `${targetElement} ${
        isDescription ? 'description' : isComment ? 'comment' : 'name'
      } cannot exceed ${maxLength} characters.`;
    }

    if (type === 'duplicate') {
      const { targetElement, name } = props;

      return `${targetElement} "${name}" already exists`;
    }

    if (type === 'custom') {
      const { customError } = props;

      return customError;
    }

    throw new UnreachableCaseError(type);
  };

  const errorMessage = getErrorMessage();

  return <Container className={className}>{errorMessage}</Container>;
};
